import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import {
    Box,
    Text,

    /* Hooks */
    useBreakpointValue,
    Skeleton
} from '@salesforce/retail-react-app/app/components/shared/ui'
import { getAssetUrl } from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

/* Hooks */
import { useOptimizely } from '../../../contexts/optimizely-context'

/* Styles */
import { useMyRewardsStyles } from '../styles/myRewardsStyles'

/* Utils */
import { renderComponentsSwitch } from '../../../components/optimizely/utils/contentRenderer'

const ExclusiveRewardsBlockCMS = React.forwardRef(({ loyaltyData, isLoyaltyDataLoading }, ref) => {
    const { rewardPageBlock, isOptimizelyLoading } = useOptimizely()
    const [cmsAndLoyaltyDataLoaded, setCmsAndLoyaltyDataLoaded] = useState(false)

    // This will fallback CMS
    const hardCodedData = {
        title: 'Enjoy Your Exclusive Rewards',
        subTitle: "And just like that... thanks to your points and your tier status, you're already earning rewards. Don't miss out!",
        backgroundImage: {
            mobileSrc: '',
            desktopSrc: ''
        }
    }

    const styles = useMyRewardsStyles()
    const isMobile = useBreakpointValue({ base: true, lg: false })
    const erbStyling = styles?.components?.exclusiveRewardsBlock
    const rewards = loyaltyData?.rewards

    useEffect(() => {
        if (!isOptimizelyLoading && !isLoyaltyDataLoading) {
            setCmsAndLoyaltyDataLoaded(true)
        }
    }, [!isOptimizelyLoading, !isLoyaltyDataLoading])

    return (
        <Box ref={ref}>
            <Box {...erbStyling.container}
                sx={{
                    backgroundImage: `url(${isMobile ? getAssetUrl(hardCodedData.backgroundImage.mobileSrc) : getAssetUrl(hardCodedData.backgroundImage.desktopSrc)})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>

                {rewardPageBlock && rewardPageBlock?.RewardTitleResponsiveText ? (
                    renderComponentsSwitch(rewardPageBlock?.RewardTitleResponsiveText?.Expanded, {
                        overwriteRTBTextStyle: { ...styles.sectionTitle }
                    })
                ) : (
                    <Box
                        {...styles.sectionTitle}
                        sx={styles.highlighted}
                        dangerouslySetInnerHTML={{ __html: hardCodedData.title }} />
                )}

                {rewardPageBlock && rewardPageBlock?.RewardSubtitleResponsiveText &&
                    renderComponentsSwitch(rewardPageBlock?.RewardSubtitleResponsiveText?.Expanded, {
                        overwriteRTBTextStyle: { ...styles.sectionSubTitle }
                    })
                }

                {rewardPageBlock && rewardPageBlock?.RewardDescriptionResponsiveText ? (
                    renderComponentsSwitch(rewardPageBlock?.RewardDescriptionResponsiveText?.Expanded, {
                        overwriteRTBTextStyle: { ...styles.sectionDescription, ...erbStyling.sectionDescription }
                    })
                ) : (
                    <Text  {...styles.sectionDescription} {...erbStyling.sectionDescription}>
                        {hardCodedData.subTitle}
                    </Text>
                )}

                <Skeleton isLoaded={cmsAndLoyaltyDataLoaded} {...erbStyling.tiles} {...styles.componentWrapper}>
                    {rewards?.map((reward, index) => {
                        const availableCustomerRewardId = reward['tile-content-id']
                        const availableCustomerReward = rewardPageBlock?.RewardTileList?.filter((item) => item?.ContentLink?.Expanded?.RewardTileSFID === availableCustomerRewardId)
                        if (availableCustomerReward?.length > 0) {
                            return renderComponentsSwitch(availableCustomerReward[0]?.ContentLink?.Expanded)
                        }
                    })}
                </Skeleton>
            </Box>
        </Box>
    )
})

ExclusiveRewardsBlockCMS.propTypes = {
    loyaltyData: PropTypes.object,
    isLoyaltyDataLoading: PropTypes.bool
}

export default ExclusiveRewardsBlockCMS
